import { render, staticRenderFns } from "./PositionDisplay.vue?vue&type=template&id=52bc5188&scoped=true&"
import script from "./PositionDisplay.vue?vue&type=script&lang=js&"
export * from "./PositionDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PositionDisplay.vue?vue&type=style&index=0&id=52bc5188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc5188",
  null
  
)

export default component.exports